{
  "authenticate": "S'authentifier"
}
